import me from './me'
import notifications from './notifications'
import providers from './providers'
import sync from './sync'
import { patientsSlice } from '~/entities/person'
import usersSlice from './users'
import { chatSlice } from '~/features/member-profile/communication'
import { combineReducers } from 'redux'

import { assigneeGroupsReducer } from '~/entities/assignee-group'

export const rootReducer = combineReducers({
  me,
  notifications,
  providers,
  sync,
  chat: chatSlice.reducer,
  patients: patientsSlice.reducer,
  users: usersSlice.reducer,
  assigneeGroups: assigneeGroupsReducer,
})

export type RootState = ReturnType<typeof rootReducer>
